/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { DetailedLedgerOwnersCapitalService } from "services/detailed-ledger-owners-capital";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    // Safe first document date
    const firstItem = item.items?.[0];
    const docDate = firstItem?.documentDate
      ? new Date(firstItem.documentDate).toLocaleDateString("vi-VN")
      : "";

    // Use closingBalance safely
    const closing = item.closingBalance || {};
    const formatCapital = (value) => formatCurrency.format(value || 0);

    return {
      id: item._id,
      year: item.year || "N/A",
      company: item.company?.name || "N/A",
      contributedCapital: formatCapital(closing.contributedCapital),
      sharePremium: formatCapital(closing.sharePremium),
      bondConversionOption: formatCapital(closing.bondConversionOption),
      otherCapital: formatCapital(closing.otherCapital),
      totalCapital: formatCapital(
        (closing.contributedCapital || 0) +
          (closing.sharePremium || 0) +
          (closing.bondConversionOption || 0) +
          (closing.otherCapital || 0)
      ),
      docDate,
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Năm", accessor: "year", width: "8%" },
    { Header: "Đơn vị", accessor: "company", width: "20%" },
    { Header: "Vốn góp", accessor: "contributedCapital", width: "12%" },
    { Header: "Thặng dư vốn", accessor: "sharePremium", width: "12%" },
    { Header: "Quyền chọn chuyển đổi TP", accessor: "bondConversionOption", width: "15%" },
    { Header: "Vốn khác", accessor: "otherCapital", width: "12%" },
    { Header: "Tổng vốn (cuối kỳ)", accessor: "totalCapital", width: "12%" },
    { Header: "Ngày CT đầu", accessor: "docDate", width: "10%" },
    { Header: "Ngày tạo", accessor: "createdAt" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function DetailedLedgerOwnersCapital() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await DetailedLedgerOwnersCapitalService.paginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(!createPerm); // Show button if has create permission
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Tiết Vốn Chủ Sở Hữu (S51-DN):", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default DetailedLedgerOwnersCapital;
